var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_162_48)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33359 5.23737L1.92236 2.13026C2.03732 1.52356 2.62347 1.11881 3.23155 1.22623C3.79286 1.32539 4.17665 1.82629 4.14195 2.37995L4.12442 2.51926L4.02954 3.01135C4.20728 2.86794 4.391 2.73066 4.58048 2.59983C8.67065 -0.224534 14.2477 0.760673 17.0372 4.80035C19.8267 8.84002 18.7723 14.4044 14.6821 17.2288C10.5919 20.0531 5.01488 19.0679 2.22539 15.0283C1.8767 14.5233 2.00851 13.8277 2.51978 13.4747C3.03105 13.1217 3.72818 13.2448 4.07687 13.7498C6.16899 16.7795 10.3518 17.5184 13.4194 15.4002C16.487 13.2819 17.2778 9.10859 15.1857 6.07884C13.0936 3.04908 8.91081 2.31018 5.84318 4.42845C5.67001 4.54803 5.50338 4.67461 5.34357 4.80781L5.75696 4.88347C6.36504 4.99089 6.76479 5.5698 6.64983 6.1765C6.5437 6.73653 6.0361 7.12448 5.48037 7.09637L5.34063 7.08053L2.22645 6.5304C1.66515 6.43124 1.28135 5.93034 1.31605 5.37668L1.33359 5.23737Z",
    fill: "var(--text-main)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_162_48"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "var(--text-main)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestore);
export default __webpack_public_path__ + "static/media/restore.057d935f541c878a50db2d371be3d35d.svg";
export { ForwardRef as ReactComponent };